var $filters = $('.project-filters .project-filter');
var $projects = $('.projects .project');

if ($filters.length && $projects.length) {

    // Current selection per filter. Empty string means "All".
    var state = {
        areas: '',
        types: ''
    };

    // Does the project carry `value` in its space-separated data-<filterName> list?
    var matches = function ($project, filterName, value) {
        if (!value) {
            return true;
        }

        var values = ($project.attr('data-' + filterName) || '').split(' ');

        return values.indexOf(value) !== -1;
    };

    var otherFilter = function (filterName) {
        return filterName === 'areas' ? 'types' : 'areas';
    };

    // Show projects matching both filters and re-number them so the grid keeps its top margins.
    var applyFilters = function () {
        var visibleIndex = 0;

        $projects.each(function () {
            var $project = $(this);

            if (matches($project, 'areas', state.areas) && matches($project, 'types', state.types)) {
                $project.show()
                    .attr('data-index', '' + visibleIndex)
                    .attr('data-modulo-index', '' + (visibleIndex % 2));
                visibleIndex++;
            } else {
                $project.hide()
                    .attr('data-index', '')
                    .attr('data-modulo-index', '');
            }
        });
    };

    // Gray out options that would give zero hits combined with the other filter's selection.
    var updateAvailability = function () {
        $filters.each(function () {
            var $filter = $(this);
            var name = $filter.data('filter');
            var other = otherFilter(name);

            $filter.find('li').each(function () {
                var $item = $(this);
                var value = $item.find('a').data('value') || '';

                var hits = $projects.filter(function () {
                    var $project = $(this);

                    return matches($project, name, value) && matches($project, other, state[other]);
                }).length;

                $item.toggleClass('no-hits', hits === 0);
            });
        });
    };

    $filters.on('click', 'a', function (e) {
        e.preventDefault();

        var $link = $(this);
        var $item = $link.parent();

        if ($item.hasClass('no-hits')) {
            return;
        }

        var name = $link.closest('.project-filter').data('filter');
        state[name] = $link.data('value') || '';

        $item.siblings().removeClass('active');
        $item.addClass('active');

        // Colours step up from neutral once anything other than "All" is selected
        $filters.parent().toggleClass('has-selection', !!(state.areas || state.types));

        applyFilters();
        updateAvailability();
    });

    updateAvailability();
}
